 import { applyMiddleware, createStore, Store } from 'redux';

 import logger from 'redux-logger';
 
 import thunk from 'redux-thunk';
 
 import { definition, create, combine, StateOf } from 'redux-compact';
 import { setValueReducer } from 'redux-compact/plugins';
 
 import { RodzPokoiInfo, grafikOgolnyPokoje, PokojOpcja, Info, RezerwacjaPobyt, User, ObiectRoomNumer, ObiectRoomRodzaj, webRoom, dostepnoscPokoju, WwwPortalInfo0, RozliczeniaKonto, UserData, UserDataClient, UserDataRestaurant, FirmaOddzialy, UserLoginData, Transmisja, Konfig } from '../api';
 
 import i18n from '../cfg/i18n';
 //import { NotifierData } from '../Notifier';
 import { getBrowser, getSystem, sendFcmErrorLog } from "../common/helpers";
 
 export enum DisplayState {
   start,

   logowanie,

   obiektyMenu,
   obiekty,

   zamkiMenu,
   zamkiZamki,
   zamkiPasscode,
   zamkiZamkiHasla,
   zamkiKodowanie,

   kodyBledow,

   rozliczeniaTwojeZaplaty,
   rozliczeniaTwojeDostawy,
   rozliczeniaTwojeKonto,
   rozliczeniaZalogaZaplaty,
   rozliczeniaZalogaDostawy,
   rozliczeniaZalogaKonta,

   adminMenu,
   adminDane,
   adminTwojeKonto,
 }

 export type FcmMessage = {
  text: string;
  type: number;
}

export type RozliczeniaEntry = {
   id: number;
   title: string;
   secondaryText: string;
   icon: any;
   color: string;
   onClick: () => void | Promise<void>;
   disabled?: boolean;
 }  
 
 export interface IPageState {
   displayState: DisplayState;
   prevDisplayState: DisplayState;
   loginDisplayState: DisplayState;



   userData: UserLoginData;
   userDataClient: UserDataClient;
   passwordEncoded: string;
   password: string;
   hotelOpis: string;

   zamkiPanel: number;
   passcodePanel: number;
   haslaPanel: number;

   selectedZamekId: string,
   selectedHasloId: string,
   selectedZamekHasloId: string,
   selectedKodowanieId: string,

   workerId: string;
   
   newAccount: boolean;


   openDialogError: number,

   dateFrom: string; // od dnia
   dateFromFormularz: string;
   dateTo: string; // do dnia
  

   lang: string; // język
   langPhone: { flag: string, prefix: string };
  
   browser: string,
   system: string,
   ip: string,
   fcmLogMessage: FcmMessage[],
  

   konfigi: Konfig[],
   transmisje: Transmisja[],
   refresh: number,
   passcode: string,

   selectedItemId: string,

   rozliczeniaZalogaZaplatyPanel: number;
   rozliczeniaZalogaDostawyPanel: number;
   rozliczeniaZalogaKontaPanel: number;

   jedenHotel: boolean;
   naSkrotyId: string;
 };
 
 function tomorrow(): Date {
   let d = new Date();
   d.setDate(d.getDate() + 1);
   return d;
 };
 
 function dateToString(sDate: Date): string {
   let mm = sDate.getMonth() + 1;
   let dd = sDate.getDate();
   let a = [sDate.getFullYear(), "-",
   (mm > 9 ? '' : '0') + mm, "-",
   (dd > 9 ? '' : '0') + dd
   ].join('');
 
   return a;
 };
 
 const pageState = definition<IPageState>()
   .setDefault(
     {
       displayState: DisplayState.logowanie,
       prevDisplayState: DisplayState.start,
       loginDisplayState: DisplayState.start,

       userData: new UserLoginData(),
       userDataClient: new UserDataClient(),
       passwordEncoded: "",
       password: "",
       hotelOpis: "",

       zamkiPanel: 0,
       passcodePanel: 0,
       haslaPanel: 0,

       selectedZamekId: '-1',
       selectedHasloId: '-1',
       selectedZamekHasloId: '-1',
       selectedKodowanieId: '-1',

       workerId: "",
       newAccount: false,

       openDialogError: 0,

       dateFrom: dateToString(new Date()),
       dateFromFormularz: dateToString(new Date()),
       dateTo: dateToString(tomorrow()),
      
       lang: 'pl',
       langPhone: { flag: 'pl', prefix: "48 " },
      
       browser: getBrowser(),
       system: getSystem(),
       ip: "",
       fcmLogMessage: [],

       konfigi: [],
       transmisje: [],
       refresh: 0,
       passcode: '',

       selectedItemId: '-1',

       rozliczeniaZalogaZaplatyPanel: 0,
       rozliczeniaZalogaDostawyPanel: 0,
       rozliczeniaZalogaKontaPanel: 0,

       jedenHotel: false,
       naSkrotyId: "",
     })
   .addReducers({
    setDisplayState: (pageState: IPageState, newState: DisplayState, skipLogin: boolean = false) => {
      if(pageState.userData.telefon === "" && !skipLogin){
        if (newState === DisplayState.start) {
          return ({ ...pageState, displayState: DisplayState.start })
        } else
        return ({ ...pageState, displayState: DisplayState.logowanie, loginDisplayState: newState  })
      } 
      return ({ ...pageState, displayState: newState })
    },
    setPrevDisplayState: (pageState: IPageState, newState: DisplayState) => {
      if(newState === DisplayState.start) {
        return ({ ...pageState, prevDisplayState: DisplayState.start })
      }
      return ({ ...pageState, prevDisplayState: newState })
    },
    login: (pageState: IPageState) => {
      return ({ ...pageState, displayState: pageState.loginDisplayState })
    },
    setUserData: (pageState: IPageState, userData: UserLoginData, hotelOpis: string = "") => {
      return ({ ...pageState, userData: userData, hotelOpis: hotelOpis === "" ? pageState.hotelOpis : hotelOpis })
    },
    setPassword: (pageState: IPageState, pass: string, haslo: string) => {
      return ({ ...pageState, passwordEncoded: pass, password: haslo })
    },


    setZamkiPanel: (pageState: IPageState, panel: number) => ({ ...pageState, zamkiPanel: panel }),
    setPasscodePanel: (pageState: IPageState, panel: number) => ({ ...pageState, passcodePanel: panel }),
    setHaslaPanel: (pageState: IPageState, panel: number) => ({ ...pageState, haslaPanel: panel }),

    setSelectedZamekId: (pageState: IPageState, id: string) => 
    ({...pageState, selectedZamekId: id}),
    setSelectedHasloId: (pageState: IPageState, id: string) => 
    ({...pageState, selectedHasloId: id}),
    setSelectedZamekHasloId: (pageState: IPageState, id: string) => 
    ({...pageState, selectedZamekHasloId: id}),
    setSelectedKodowanieId: (pageState: IPageState, id: string) => 
    ({...pageState, selectedKodowanieId: id}),

    setOpenDialogError: (pageState: IPageState) =>
       ({ ...pageState, openDialogError: pageState.openDialogError + 1 }),
   
     setDateFrom: (pageState: IPageState, date: string) => {
       if (date == pageState.dateFrom) return pageState
       else return ({ ...pageState, dateFrom: date })
     },
     setDateTo: (pageState: IPageState, date: string) => {
       if (date == pageState.dateTo) return pageState
       else return ({ ...pageState, basket: [], basketOld: [], dateTo: date })
     },
     setDateFromFormularz: (pageState: IPageState, date: string) => {
       if (date == pageState.dateFromFormularz) return pageState
       else return ({ ...pageState, dateFromFormularz: date })
     },
     
     setLang: (pageState: IPageState, lang: string) => {
       i18n.changeLanguage(lang)
       return ({ ...pageState, lang: lang, langPhone: { flag: lang, prefix: '' } })
     }, 
     setLangPhone: (pageState: IPageState, obj: { flag: string, prefix: string }) =>
       ({ ...pageState, langPhone: obj }),
    
     setIp: (pageState: IPageState, ip: string) =>
       ({ ...pageState, ip: ip }),
     addFcmLogMessage: (pageState: IPageState, text: string, type: number) => {
       let log = pageState.fcmLogMessage
       log.push({ text: text, type: type })
       if (log.length >= 5 || type === 2) {
         sendFcmErrorLog(log)
         return ({ ...pageState, fcmLogMessage: [] })
       }
       return ({ ...pageState, fcmLogMessage: log })
     },

      setRefresh: (pageState: IPageState) =>
      ({ ...pageState, refresh: pageState.refresh + 1 }),
      setPasscode: (pageState: IPageState, passcode: string) =>
      ({ ...pageState, passcode: passcode }),

      setWorkerId: (pageState: IPageState, id: string) => {
        return ({ ...pageState, workerId: id })
      },
      
      setNewAccouct: (pageState: IPageState, account: boolean) => {
        return ({ ...pageState, newAccount: account })
      },
      setUserDataClient: (pageState: IPageState, userData: UserDataClient) => {
        return ({ ...pageState, userDataClient: userData })
      },

      setSelectedItemId: (pageState: IPageState, selectedItemId: string) => 
     ({...pageState, selectedItemId: selectedItemId}),

     setRozliczeniaZalogaZaplatyPanel: (pageState: IPageState, panel: number) => ({ ...pageState, rozliczeniaZalogaZaplatyPanel: panel }),
     setRozliczeniaZalogaDostawyPanel: (pageState: IPageState, panel: number) => ({ ...pageState, rozliczeniaZalogaDostawyPanel: panel }),
     setRozliczeniaZalogaKontaPanel: (pageState: IPageState, panel: number) => ({ ...pageState, rozliczeniaZalogaKontaPanel: panel }),
     
     setKonfigi: (pageState: IPageState, konfigi: Konfig[]) =>
     ({ ...pageState, konfigi: konfigi }),
     setTransmisje: (pageState: IPageState, transmisje: Transmisja[]) =>
     ({ ...pageState, transmisje: transmisje }),
     setJedenHotel: (pageState: IPageState, hot: boolean) =>
     ({ ...pageState, jedenHotel: hot }),
     setNaSkrotyId: (pageState: IPageState, id: string) =>
     ({ ...pageState, naSkrotyId: id }),
  
      });
 
 /*
 const pageStates = list({ of: pageState, key: pageState  => pageState.id}).addReducers({
     add: (pageStates: PageState[], pageState: PageState) => [...pageStates, pageState]
 });
 */
 
 const auth = definition<string | undefined>().
   setDefault(window.localStorage.getItem('accessToken') || undefined).
   use(setValueReducer).addActionCreators({
     login: function (accessToken: string) {
       window.localStorage.setItem('accessToken', accessToken);
       return this.setValue(accessToken);
     },
     logout: function () {
       window.localStorage.removeItem('accessToken');
       return this.setValue(undefined)
     }
   });
 
 
 const appState = combine({
   auth,
   pageState
 });
 
 const { Actions, reduce } = create(appState);
 export type AppState = StateOf<typeof appState>;
 
 export const store: Store<AppState> = createStore(reduce,
   applyMiddleware(thunk, logger),
 );
 
 export { Actions };
 